import AdSlot from "../components/ad-slot";
import ArticleCard from "../components/article-card";
import { articles } from "../lib/articles";
import { usePageMeta } from "../lib/use-page-meta";

function Articles() {
  usePageMeta({
    title: "Articles",
    description:
      "Essays and notes on things I'm learning, small hobbies, and everyday life. Jitra, Kedah is my hometown.",
    path: "/articles",
  });

  return (
    <div className="container py-14">
      <div className="max-w-2xl">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">
          The archive
        </p>
        <h1 className="mt-2 font-serif text-4xl font-semibold tracking-tight sm:text-5xl">
          Articles
        </h1>
        <p className="mt-4 text-lg leading-8 text-muted-foreground">
          Essays and notes on things I&apos;m learning, small hobbies, and living a
          little more slowly. Most of it is personal, and none of it is expert advice.
        </p>
      </div>

      <div className="mt-10 grid gap-5 md:grid-cols-2">
        {articles.map((article) => (
          <ArticleCard key={article.slug} article={article} />
        ))}
      </div>

      <AdSlot />
    </div>
  );
}

export default Articles;
